import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import { Toaster } from './components/ui/sonner';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import ClientDashboard from './pages/ClientDashboard';
import CollaboratorDashboard from './pages/CollaboratorDashboard';
import PrestadorDashboard from './pages/PrestadorDashboard';
import '@/App.css';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, userProfile, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505]">
        <div className="text-white">Carregando...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && userProfile && !allowedRoles.includes(userProfile.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

const AppRoutes = () => {
  const { user, userProfile, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505]">
        <div className="text-white">Carregando...</div>
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  // Redirect to appropriate dashboard based on role
  if (userProfile) {
    if (userProfile.role === 'admin') {
      return <AdminDashboard />;
    } else if (userProfile.role === 'client') {
      return <ClientDashboard />;
    } else if (userProfile.role === 'collaborator') {
      return <CollaboratorDashboard />;
    } else if (userProfile.role === 'prestador') {
      return <PrestadorDashboard />;
    }
  }

  return <Login />;
};

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/*" element={<AppRoutes />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </AuthProvider>
  );
}

export default App;
